import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ToInlineCommaList } from '../../../../lib/helpers/StringHelper';
import { Actions } from '../../rules/Actions';
import { getItemValueForAction } from './getItemValueForAction';

export function getItemDisplayValuesForActions(item: SmartSendItemApiModel, actions: string[]): string {
  // Specal case for dims
  if (
    actions.length === 3 &&
    actions.includes(Actions.Item_Length) &&
    actions.includes(Actions.Item_Height) &&
    actions.includes(Actions.Item_Width)
  ) {
    return `${item.PackageDimensions.Length} x ${item.PackageDimensions.Width} x ${item.PackageDimensions.Height}cm`;
  }

  // This is only displayed when both are true, so we can just return 'Yes'
  // Usual ExtendedBase Logic madness
  if (actions.length === 2 && actions.every((t) => t == Actions.Extra_Cover || t == Actions.Extra_ExtendedBaseCover)) {
    return `Yes`;
  }

  const output: string[] = [];

  actions.forEach((a) => {
    switch (a) {
      case Actions.Item_Length:
        output.push(`${item.PackageDimensions.Length}cm`);
        break;

      case Actions.Item_Height:
        output.push(`${item.PackageDimensions.Height}cm`);
        break;

      case Actions.Item_Width:
        output.push(`${item.PackageDimensions.Width}cm`);
        break;

      case Actions.Item_Weight:
        output.push(`${item.PackageDimensions.Weight}kg`);
        break;

      case Actions.Item_TariffCode:
        output.push(item.MarketplaceOrderLines.map((x) => x.Product?.TariffCode).filter((x) => !!x)[0]);
        break;

      case Actions.Item_Service:
      case Actions.Item_CourierService:
        output.push(item.Service.Name);
        break;

      case Actions.Extra_Cover:
      case Actions.Extra_Sms:
      case Actions.Extra_PrintInStore:
      case Actions.Extra_ExtendedBaseCover:
      case Actions.Extra_DeliveryGuarantee:
      case Actions.Extra_Signature:
        return output.push(getItemValueForAction(item, a) === 'true' ? 'Yes' : 'No');

      default:
        output.push(getItemValueForAction(item, a));
    }
  });

  return ToInlineCommaList(output);
}
